import '../Sass/main.scss';
import $ from 'cash-dom';
import 'bootstrap/js/src/base-component';
import 'bootstrap/js/src/button';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/offcanvas';
import './helpers/polyfills';

// Components
import events from './helpers/events';
import video from './elements/video';
import tabs from './elements/tabs';
import scroll from './elements/scroll';
import scrollShadow from './elements/scroll-shadow';
import anchor from './elements/anchor';
window.$ = $;

// Import all
const modules = [events, video, tabs, scroll, scrollShadow, anchor];
modules.forEach(module => {
  module();
});

// Dynamic components import
const components = [{
  el: '.footer-section-content',
  fileName: 'elements/footer'
}, {
  el: '.bp-page-header',
  fileName: 'elements/header'
}, {
  el: '.frame',
  fileName: 'components/base-animation'
}, {
  el: '.frame-type-sticky_inpage_nav',
  fileName: 'components/sticky_inpage-nav'
}, {
  el: '.frame-type-animated_keyvisual',
  fileName: 'components/animated_keyvisual'
}, {
  el: '.animated_logo',
  fileName: 'components/animated_logo'
}, {
  el: '.frame-type-device_preview',
  fileName: 'components/device_preview'
}, {
  el: 'select',
  fileName: 'components/select'
}, {
  el: '.frame-type-fact_group',
  fileName: 'components/facts'
}, {
  el: '.timeline',
  fileName: 'components/timeline'
}, {
  el: '.news-selected-list-view',
  fileName: 'components/news'
}, {
  el: '.topSuccessStoryCard',
  fileName: 'components/top_stories'
}, {
  el: '.powermail_form',
  fileName: 'components/formsValidation'
}, {
  el: '.js-search-form',
  fileName: 'components/initAutocomplete'
}, {
  el: '.benefit',
  fileName: 'components/benefits'
}, {
  el: '.quote-slider',
  fileName: 'components/quote_slider'
}, {
  el: '.table-responsive',
  fileName: 'components/table'
}, {
  el: '#personio-iframe',
  fileName: 'elements/personio'
}];
const componentImport = async (el, fileName) => {
  if (!document.querySelector(el)) return;
  const module = await import(`./${fileName}`);
  module.default();
};
components.forEach(component => {
  const {
    el,
    fileName
  } = component;
  componentImport(el, fileName);
});